export default __webpack_public_path__ + "static/media/bonusShopIcon.3fbff4aa.svg";